/*
 *  A special combineReducers function (different from redux.combineReducers) that's comaptible with the react context API
 *
 *  See: https://stackoverflow.com/questions/57296549/hooks-combine-multiple-reducers-when-using-usereducer/57298115#57298115
 */
export default (...reducers) =>
  (state, action) =>
    reducers.reduce((newState, reducer) =>
         reducer(newState, action), state);
